<template>
  <div
    id="select-ingredient-modal-3"
    tabindex="-1"
    aria-hidden="true"
    class="fixed top-0 left-0 right-0 z-50 hidden w-full px-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] md:h-full"
  >
    <div class="relative w-full h-full max-w-6xl md:h-auto">
      <!-- Modal content -->
      <div class="relative bg-white rounded-lg shadow ">
        <button
          type="button"
          class="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center  "
          @click="onClose"
        >
          <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clip-rule="evenodd"
            />
          </svg>
          <span class="sr-only">Close modal</span>
        </button>
        <!-- Modal header -->
        <div class="px-6 py-4 border-b rounded-t  bg-gray-600">
          <h3 class="text-base font-semibold text-gray-100 lg:text-xl ">
            {{ labels["TITLE_INGREDIENTS"][lg] }}
          </h3>
        </div>
        <!-- Modal body -->
        <div class="p-6 w-full bg-white-100">
          <p class="text-sm font-normal text-gray-500 ">
            {{ labels["TITLE_SELECT_PRODUCT_TYPE_COMMENT"][lg] }}
          </p>

          <label for="default-search" class="mb-2 text-sm font-medium text-gray-900 sr-only ">Search</label>
          <div class="hidden relative">
            <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              <svg class="w-4 h-4 text-gray-500 " aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
              </svg>
            </div>
            <input
              id="default-search"
              v-model="searchText"
              type="search"
              class="block w-full p-4 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500      "
              placeholder="Search Mockups, Logos..."
              required
              @input="onSearchInput"
              @change="onSearchChange"
            />
          </div>

          <div class="grid grid-cols-4 pt-4">
            <ul class="border-2 border-gray-200 space-y-3 overflow-y-auto h-96 w-full" :class="{ 'bg-blue-100': loading0, 'bg-gray-100': loading0 }">
              <li class="hidden w-full bg-gray-600 text-white">0</li>
              <li v-for="item in filteredTypes0" :key="item._id" class="cursor-pointer">
                <div
                  class="border border-gray-200 mx-1 flex items-center px-1 py-3 text-base font-bold rounded-lg group hover:shadow   "
                  :class="{ 'text-white bg-gray-600 hover:bg-gray-700': selected0 == item._id, 'text-gray-900 bg-gray-50 hover:bg-gray-100': selected0 != item._id }"
                  @click="onProductSelect0(item)"
                >
                  <i class="hidden fa-solid fa-xl fa-solid fa-chevron-right" />
                  <span class="flex-1 text-left px-1 whitespace-nowrap text-sm truncate">{{ item.name[lg] }}</span>
                  <i v-if="selected0 == item._id && item.hasChildren" class="fa-solid fa-lg fa-chevron-right mr-1" />
                  <span class="hidden inline-flex items-center justify-center px-2 py-0.5 ml-3 text-xs font-medium text-gray-500 bg-gray-200 rounded  ">Popular</span>
                </div>
              </li>
            </ul>

            <ul class="border-2 border-gray-200 space-y-3 overflow-y-auto h-96 w-full" :class="{ 'bg-blue-100': loading1, 'bg-gray-100': loading1 }">
              <li class="hidden w-full bg-gray-600 text-white">1</li>
              <li v-for="item in filteredTypes1" :key="item._id" class="cursor-pointer">
                <div
                  class="border border-gray-200 mx-1 flex items-center p-3 text-base font-bold rounded-lg group hover:shadow   "
                  :class="{ 'text-white bg-gray-600 hover:bg-gray-700': selected1 == item._id, 'text-gray-900 bg-gray-50 hover:bg-gray-100': selected1 != item._id }"
                  @click="onProductSelect1(item)"
                >
                  <i class="hidden fa-solid fa-xl fa-circle" />
                  <span class="flex-1 text-left px-1 whitespace-nowrap text-sm truncate">{{ item.name[lg] }}</span>
                  <i v-if="selected1 == item._id && item.hasChildren" class="fa-solid fa-lg fa-chevron-right mr-1" />
                  <span class="hidden inline-flex items-center justify-center px-2 py-0.5 ml-3 text-xs font-medium text-gray-500 bg-gray-200 rounded  ">Popular</span>
                </div>
              </li>
            </ul>

            <ul v-if="mode == 'select-ingredient'" class="border-2 border-gray-200 space-y-3 overflow-y-auto h-96 w-full" :class="{ 'bg-gray-50': loading2, 'bg-gray-100': loading2 }">
              <li class="hidden w-full bg-gray-600 text-white">2</li>
              <li v-for="item in filteredTypes2" :key="item._id" class="cursor-pointer">
                <div
                  class="flex items-center p-3 text-base font-bold rounded-lg group hover:shadow   "
                  :class="{ 'text-white bg-gray-600 hover:bg-gray-700': selected2 == item._id, 'text-gray-900 bg-gray-50 hover:bg-gray-100': selected2 != item._id }"
                  @click="onProductSelect2(item)"
                >
                  <i class="hidden fa-solid fa-xl fa-circle" />
                  <span class="flex-1 text-left px-1 whitespace-nowrap text-sm">{{ item.name[lg] }}</span>
                  <i v-if="selected2 == item._id && item.hasChildren" class="fa-solid fa-lg fa-chevron-right mr-1" />
                  <span class="hidden inline-flex items-center justify-center px-2 py-0.5 ml-3 text-xs font-medium text-gray-500 bg-gray-200 rounded  ">Popular</span>
                </div>
              </li>
            </ul>

            <ul v-if="mode == 'select-ingredient'" class="border-2 border-gray-200 space-y-3 overflow-y-auto h-96 w-full">
              <li class="hidden w-full bg-gray-600 text-white">3</li>
              <li v-for="item in filteredTypes3" :key="item._id" class="cursor-pointer">
                <div
                  class="border border-gray-200 mx-1 flex items-center p-3 text-base font-bold rounded-lg group hover:shadow   "
                  :class="{ 'text-white bg-gray-600 hover:bg-gray-700': selected3 == item._id, 'text-gray-900 bg-gray-50 hover:bg-gray-100': selected3 != item._id }"
                  @click="onProductSelect3(item)"
                >
                  <i class="fa-solid fa-xl hidden fa-circle" />
                  <span class="flex-1 text-left px-1 whitespace-nowrap text-sm truncate">{{ item.name[lg] }}</span>

                  <span class="hidden inline-flex items-center justify-center px-2 py-0.5 ml-3 text-xs font-medium text-gray-500 bg-gray-200 rounded  ">Popular</span>
                </div>
              </li>
            </ul>

            <ul v-if="mode == 'select-product'" class="col-span-2 border-2 border-gray-200 space-y-3 overflow-y-auto h-96 w-full">
              <li class="hidden w-full bg-gray-600 text-white">3</li>
              <li v-for="item in filteredTypes2" :key="item._id" class="cursor-pointer">
                <div
                  class="border border-gray-200 mx-1 flex items-center p-3 text-base font-bold rounded-lg group hover:shadow   "
                  :class="{ 'text-white bg-gray-600 hover:bg-gray-700': selected2 == item._id, 'text-gray-900 bg-gray-100 hover:bg-gray-100': selected2 != item._id }"
                  @click="onProductSelect2(item)"
                >
                  <img class="w-12 h-12 rounded-lg ml-2" :src="imagePath(item)" />
                  <span class="flex-1 text-left px-1 whitespace-nowrap text-sm truncate px-2">{{ item.name[lg] }}</span>

                  <span class="hidden inline-flex items-center justify-center px-2 py-0.5 ml-3 text-xs font-medium text-gray-500 bg-gray-200 rounded  ">Popular</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="flex items-center justify-between px-4 py-3 mt-3 bg-gray-100 border-t rounded-b">
          <div class="text-gray-500 italic text-xs">*734*</div>
          <div class="flex items-center justify-end">
            <button
              type="button"
              class="mr-3 py-2.5 px-5 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-primary-700 focus:z-10 focus:ring-4 focus:ring-gray-200      "
              @click="onClose()"
            >
              Annuler
            </button>
            <button
              type="button"
              :disabled="!isActive()"
              class="inline-flex items-center focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center  "
              :class="{ 'text-white bg-gray-600 hover:bg-gray-700 focus:ring-4 ': isActive(), 'text-white bg-gray-300  ': !isActive() }"
              @click="onValidate"
            >
              Valider
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*
  *"Je veux une classification hiérarchique en 5 niveaux maximum pour une liste d’ingrédients utilisée dans un logiciel SaaS. La racine est "Ingrédient" (inutile de l’indiquer dans la classification).
  
  Chaque ingrédient doit être classé en catégories logiques et hiérarchiques en fonction de son origine et son usage.
  Ajoute un niveau supplémentaire lorsqu'il est pertinent (exemple : pour les viandes, précise l'animal).
  Classe les sels, épices, sucres, liquides, boyaux, et additifs selon une logique claire.
  Maintiens une structure simple, lisible et organisée, avec des sous-catégories pertinentes.
  Voici la liste des ingrédients à classer :
  
  Jambon de Porc
  Pied de Porc
  Viande de Sanglier
  Joue de Bœuf
  Sel nitrité
  Poivre noir moulu
  Muscade moulue
  Carvi en poudre
  Ail en poudre
  Coriandre moulue
  Vin rouge
  Boyau naturel
  Boyau artificiel Nalo Top Brun 60
  Glace
  Sel de mer fin
  Sucre : Dextrose
  Liant Cutter Mix PH 7.3
  Génère la classification hiérarchique détaillée avec 5 niveaux maximum, en respectant une structure logique et exhaustive."*
  */

import service from "@/services/FullService.vue";
import labels from "@/assets/lg/product-types.json";

import { mapGetters } from "vuex";
export default {
  name: "SelectIngredientModal3",
  props: {
    refresh: String,
    category: String,
    type: String,
  },
  data() {
    return {
      lg: "FR",
      labels: labels,
      searchText: "",
      records: [],
      src: "",
      mode: "select-ingredient",
      isValid: false,
      currentSource: null,
      selectIngredient: {
        step0: "668cecd29535b23c096b6407",
        step1: "67cab27ec9b211ee3df4f31a",
        step2: "67cab4bdc9b211ee3df4f31b",
        step3: "67cab4ddc9b211ee3df4f31c",
      },
      selectRawProduct: {
        step0: "686d30eccf90476c6799f025",
        step1: "686d3f4dcf90476c6799f026",
        step2: "686d4a1ecf90476c6799f02e",
        step4: "",
      },
      filteredTypes0: [],
      filteredTypes1: [],
      filteredTypes2: [],
      filteredTypes3: [],
      filteredTypes4: [],

      allTypes0: [],
      allTypes1: [],
      allTypes2: [],
      allTypes3: [],
      allTypes4: [],

      loading0: false,
      loading1: false,
      loading2: false,
      loading3: false,
      loading4: false,

      selected: null,
      selected0: null,
      selected1: null,
      selected2: null,
      selected3: null,
    };
  },
  computed: {
    ...mapGetters({ user: "StateUser" }),
    isLoggedIn: function () {
      return this.$store.getters.isAuthenticated;
    },
  },
  watch: {
    refresh: async function () {
      let data = { records: [] };

      this.currentSource = this.selectIngredient;

      if (this.type == "select-product") {
        this.currentSource = this.selectRawProduct;
        this.mode = "select-product";
      }

      if (this.currentSource != undefined) {
        data = await this.loadItems(this.currentSource.step0, null);
      }

      this.allTypes0 = data.records;

      this.filteredTypes0 = this.allTypes0;

      this.selected0 = null;
      this.selected = null;
      this.selected1 = null;
      this.selected2 = null;
      this.selected3 = null;
    },
  },
  async mounted() {
    if (this.user == undefined) {
      //this.$router.push("/login");
      window.location = "/login";
      return;
    }
    this.currentSource = this.selectIngredient;

    if (this.type == "select-product") {
      this.currentSource = this.selectRawProduct;
      this.mode = "select-product";
    }
    //let data = await this.loadItems("668cecd29535b23c096b6407", null);

    let data = { records: [] };

    if (this.currentSource != undefined) {
      data = await this.loadItems(this.currentSource.step0, null);
    }

    this.allTypes0 = data.records;

    this.filteredTypes0 = this.allTypes0;
  },
  methods: {
    isActive() {
      if (this.selected == undefined) return false;
      return !this.selected.hasChildren;
    },

    onValidate() {
      let item = this.selected;

      if (item.path == undefined) item.path = item.name;
      this.$emit("select", this.selected);
    },

    onSearchInput() {
      let lg = this.lg;
      let searchText = this.searchText;
      this.filteredTypes = this.allTypes?.filter(function (el) {
        return el.name[lg].toUpperCase().includes(searchText.toUpperCase());
      });
    },
    imagePath(item) {
      let addSquare = "?icon=true";
      let path = item?.image_id;

      if (path == undefined) return this.blank;

      // if (path.url == undefined) return this.blank

      if (path.indexOf("http") == 0) {
        // return path + "?icon=true";
        return path + addSquare;
      }

      if (path.indexOf("data:") == 0) return path;

      return this.host_media + path + addSquare;
      //   return this.host_media + path + "?icon=true&test=1";
    },
    onSearchChange() {},

    async loadItems(source_id, parent_id, level = 0) {
      let data = [];
      let limit = 100;
      let offset = 0;
      let filter = {};

      filter = { parent_id: parent_id, category: this.category };

      if (this.type == "select-product") {
        filter = { parent_id: parent_id };

        if (level == 2) filter = {};
         
      }

      let collection = "data-sources/" + source_id + "/records";
      // let collection = "ingredient-types"
      this.src = collection;
      data = await service.getData(collection, this.user?.token, Object.assign({}, { limit: limit, offset: offset }, filter));

      if (data == null) {
        data = [];
      }
      return data;
    },

    async onProductSelect0(item) {
      this.selected0 = item._id;
      this.selected = item;
      this.selected1 = null;
      this.selected2 = null;
      this.selected3 = null;

      this.loading1 = true;
      //  let data = await this.loadItems("67cab27ec9b211ee3df4f31a", item._id);

      let data = { records: [] };

      if (this.currentSource != undefined) {
        data = await this.loadItems(this.currentSource.step1, item._id);
      }

      this.allTypes1 = data.records;
      this.loading1 = false;
      this.filteredTypes1 = this.allTypes1;

      this.filteredTypes2 = [];
      this.filteredTypes3 = [];

      this.allTypes2 = [];
      this.allTypes3 = [];

      //  this.$emit("select", item)
    },

    async onProductSelect1(item) {
      this.selected1 = item._id;
      this.selected = item;
      this.selected2 = null;
      this.selected3 = null;

      this.loading2 = true;

      // let msg  = "selected=" + JSON.stringify(this.selected)
   
      // let data = await this.loadItems("67cab4bdc9b211ee3df4f31b", item._id);

      let data = { records: [] };

      if (this.currentSource != undefined) {
        if (this.type == "select-product") {
          data = await this.loadItems(this.currentSource.step2, null, 2);
        } else {
          data = await this.loadItems(this.currentSource.step2, item._id);
          //  data = await this.loadItems(this.currentSource.step3, item._id);
        }
      }

      this.allTypes2 = data.records;
      this.loading2 = false;
      this.filteredTypes2 = this.allTypes2;

      this.filteredTypes3 = [];
      this.allTypes3 = [];

      //  this.$emit("select", item)
    },

    async onProductSelect2(item) {
      this.selected2 = item._id;
      this.selected = item;
      this.selected3 = null;
      this.loading3 = true;
      // let data = await this.loadItems("67cab4ddc9b211ee3df4f31c", item._id);

      let data = { records: [] };

      if (this.currentSource != undefined) {
        if (this.type == "select-product") {
          data = await this.loadItems(this.currentSource.step3, null, 2);
        } else {
          data = await this.loadItems(this.currentSource.step3, item._id);
          //  data = await this.loadItems(this.currentSource.step3, item._id);
        }
      }

      this.allTypes3 = data.records;
      this.loading3 = false;
      this.filteredTypes3 = this.allTypes3;

      //  this.$emit("select", item)
    },

    async onProductSelect3(item) {
      this.selected3 = item._id;
      this.selected = item;
       
      //  this.loading4 = true;
      //  let data = await this.loadItems("67cab4ddc9b211ee3df4f31c", item._id)
      //  this.allTypes4 = data.records;
      //  this.loading4 = false;
      //  this.filteredTypes4 = this.allTypes4

      //   this.$emit("select", item);
    },

    onClose() {
      this.$emit("close");
    },
  },
  components: {},
};
</script>
